var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "lastMinuteHeader",
      attrs: { "data-name": _vm.lodging.datestring },
    },
    [
      _c("h2", [
        _vm._v(
          _vm._s(_vm.arrivalFormatted) +
            " " +
            _vm._s(_vm.translations.terms.to) +
            " " +
            _vm._s(_vm.departureFormatted) +
            " (" +
            _vm._s(_vm.durationFormatted) +
            ")"
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }